import { render, staticRenderFns } from "./UploadBoxElement.vue?vue&type=template&id=6569cad3&scoped=true&"
import script from "./UploadBoxElement.vue?vue&type=script&lang=ts&"
export * from "./UploadBoxElement.vue?vue&type=script&lang=ts&"
import style0 from "./UploadBoxElement.vue?vue&type=style&index=0&id=6569cad3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6569cad3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
